import script from "./Matches.vue?vue&type=script&setup=true&lang=ts"
export * from "./Matches.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__